import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, ModalService, ModalSize, SubContent } from '@cv-invision/core';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
// Models
import { ORIGIN } from '../../models/partial-integration.model';
import { DATA_MIMUTUAL, DATA_RELIANCEFIRST } from '../../models/integrations';
// Components
import { RequestInformationPartialComponent } from '../request-information-partial-log/request-information-partial-log.component';
// Services
import { PartialIntegrationService } from '../../services/data-loader-partial-integration.service';

@Component({
	selector: 'cv-orders-log-partial-description',
	templateUrl: './logs-partial-description.component.html',
	styleUrls: ['./logs-partial-description.component.scss']
})
export class LogsPartialDescriptionComponent extends SubContent implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<void> = new Subject<void>();
	origin: ORIGIN;
	log: any;
	logsInputs: any;

	constructor(
		public broadcastService: BroadcastService,
		private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private dataLoaderService: PartialIntegrationService
	) {
		super(broadcastService);
	}

	/**
     * Initialize component data on component initialization
     */
	ngOnInit(): void {
		this.initializeData();
		this.openSubContent(null, null);
	}

	/**
     * Initialize data based on the data source
     */
	private initializeData(): void {
		switch (this.data?.source) {
			case ORIGIN.RELIANCE_FIRST:
				this.log = DATA_RELIANCEFIRST(this.data);
				this.origin = ORIGIN.RELIANCE_FIRST;
				break;
			case ORIGIN.MI_MUTUAL:
				this.log = DATA_MIMUTUAL(this.data);
				this.origin = ORIGIN.MI_MUTUAL;
				break;
		}
	}

	/**
     * Display request information based on the data source
     */
	displayRequestInfo(): void {
		let shouldGetOrderDetails = false;
		let paramId = null;

		switch (this.data.source) {
			case ORIGIN.RELIANCE_FIRST:
				shouldGetOrderDetails = true;
				paramId = this.data.id;
				break;
			case ORIGIN.MI_MUTUAL:
				if (this.data.loanNumber && this.data.loanNumber.length > 0) {
					shouldGetOrderDetails = true;
				}

				paramId = this.data.loanNumber;
				break;
		}

		if (shouldGetOrderDetails) {
			this.dataLoaderService.getOrderDetails(paramId, this.origin)
				.pipe(
					takeUntil(this.atComponentDestroy),
					catchError(error => {
						return throwError(error);
					})
				).subscribe(res => {
					this.logsInputs = res;
					this.openRequestInformationModal(this.logsInputs);
				});
		}
	}

	/**
     * Open a modal to display request information
     * @param logsInputs The logs input data to display in the modal
     */
	openRequestInformationModal(logsInputs: any): void {
		this.modalService.open({
			componentFactoryResolver: this.componentFactoryResolver,
			component: RequestInformationPartialComponent,
			data: {
				request: { data: logsInputs }
			},
			modalConfiguration: {
				title: 'Documents',
				modalSize: ModalSize.XXL
			}
		}).pipe(
			takeUntil(this.atComponentDestroy)
		).subscribe(result => {
			if (result.status === 'accept' && result.definition) {
				// Handle accepted result
			}
		});
	}

	/**
     * Extract the loan number from the message request
     * @param messageRequest The message request containing the loan number
     * @returns The extracted loan number
     */
	extractLoanNumber(messageRequest: string): string {
		const requestObj = JSON.parse(messageRequest);
		return requestObj.FileNumber;
	}

	/**
     * Clean up resources when the component is destroyed
     */
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.complete();
	}
}